import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui-kit/button';
import { useToast } from '@/hooks/use-toast';
import { useAuthStore } from '@/state/store/auth';
import { CrossAppSignInLinkError } from '../services/subscription.service';
import { useOpenSignaturePurchase } from '../hooks/use-open-signature-purchase';

interface PurchaseButtonProps {
  className?: string;
}

export const PurchaseButton = ({ className }: PurchaseButtonProps) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const sigOrgId = useAuthStore((state) => state.sigOrgId);
  const { openPurchase, isOpening } = useOpenSignaturePurchase();

  const handleClick = async () => {
    try {
      await openPurchase();
    } catch (error) {
      const code = error instanceof CrossAppSignInLinkError ? error.message : '';
      const description =
        code === 'POPUP_BLOCKED'
          ? t('PURCHASE_POPUP_BLOCKED', {
              defaultValue: 'Please allow pop-ups for this site and try again.',
            })
          : code === 'MISSING_SIG_ORG'
            ? t('PURCHASE_MISSING_ORG', {
                defaultValue: 'Connect a Signature organization before purchasing.',
              })
            : t('PURCHASE_OPEN_ERROR', {
                defaultValue: 'Could not open Signature Store. Please try again.',
              });
      toast({ variant: 'destructive', title: t('PURCHASE_OPEN_FAILED', { defaultValue: 'Purchase failed' }), description });
    }
  };

  return (
    <Button className={className} onClick={handleClick} disabled={isOpening || !sigOrgId}>
      {isOpening ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
      {t('PURCHASE_BUTTON', { defaultValue: 'Purchase' })}
    </Button>
  );
};
